import script from "./UploadSlideDeckModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSlideDeckModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadSlideDeckModal.vue?vue&type=style&index=0&id=5340f542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5340f542"]])

export default __exports__